import React, { useState, useRef, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import { Grid, Dropdown, Image } from 'semantic-ui-react'
import { useHistory } from "react-router-dom";
import onging from "../assets/home/onging_img.png";
import reward_img from "../assets/home/BitmapA.png";
import { StarButton } from '../components'







const Rewards = () => {

    // const [search, setSearch] = useState('')
    // const [type, setType] = useState(1)
    // const token = useSelector((state) => state.auth.token)
    // const timer = useRef();


    // const handleSearch = (value1 = null, value2 = null) => {
    //     let searchs = value1 ? value1 : search
    //     let types = value2 ? value2 : type
    //     let param = { token }
    //     if (searchs) {
    //       param.heading = searchs
    //     }
    //     if (types) {
    //       let category = options.find(x => (x.key == types))
    //       param.category = category ? category.text : null
    //     }
        
    //   }




    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    const options = [
        { key: 1, text: 'Claimed ', value: 1 },
        { key: 2, text: 'Unclaimed ', value: 2 },
        
    ]
    const rewardss = [
        { name: 'Garv Pride & Honour', desc: "Get Extra ₹900.00 off on your Electronics purchase with Amazon", valid: "Valid till 15th Nov, 2021", status: 'active' },
        { name: 'Garv Pride & Honour', desc: "Get Extra ₹900.00 off on your Electronics purchase with Amazon", valid: "Valid till 15th Nov, 2021", status: 'active' },
        { name: 'Garv Pride & Honour', desc: "Get Extra ₹900.00 off on your Electronics purchase with Amazon", valid: "Valid till 15th Nov, 2021", status: 'active' },
        { name: 'Garv Pride & Honour', desc: "Get Extra ₹900.00 off on your Electronics purchase with Amazon", valid: "Valid till 15th Nov, 2021", status: 'active' },
        { name: 'Garv Pride & Honour', desc: "Get Extra ₹900.00 off on your Electronics purchase with Amazon", valid: "Valid till 15th Nov, 2021", status: 'inactive' },
        { name: 'Garv Pride & Honour', desc: "Get Extra ₹900.00 off on your Electronics purchase with Amazon", valid: "Valid till 15th Nov, 2021", status: 'inactive' },
        { name: 'Garv Pride & Honour', desc: "Get Extra ₹900.00 off on your Electronics purchase with Amazon", valid: "Valid till 15th Nov, 2021", status: 'inactive' },
        { name: 'Garv Pride & Honour', desc: "Get Extra ₹900.00 off on your Electronics purchase with Amazon", valid: "Valid till 15th Nov, 2021", status: 'inactive' },
    ]
    return (
        <>
            <div className="container_bg clearall">
                <div className="Notification_sec">
                    <h3><span>My </span>Rewards</h3>
                    <h5>Lorem ipsum dolor sit amet, consectetur</h5>
                    <div className="input_boxs">
                        <div className="input_text" Stackable>
                            <div className="rewards_sec">
                                <img className="onging_img" src={onging} />
                                <Dropdown selection options={options} placeholder='Claimed Gifts'
                                // onChange={(e, { value }) => {
                                //     setType(value)
                                //     handleSearch(null, value)
                                //   }}
                                  
                                
                                />
                            </div>

                        </div>
                    </div>
                    <div className="garvs clearall">
                        <Grid >
                            <Grid.Row className="grid-row">
                                {rewardss.map((item, key) => <Grid.Column key={key} mobile={16} tablet={8} computer={4}>
                                    <div className="inner_sec">
                                        <img className="reward_img" src={reward_img} />
                                        <h4>{item.name}</h4>
                                        <p>{item.desc}</p>
                                        <h5>{item.valid}</h5>
                                        {item.status == 'active' ? <div>
                                            <StarButton background={'mainBg smallButHight'} width="270px" height="130px" title="Claim Now" onClickAction={() => history.push("/giftcard")} className = "starBtn" />
                                        </div> :
                                            <div>
                                                <StarButton isGray={true} disableStar={true} height="50px" title="Claim Now" onClickAction={() => history.push("/giftcard")} />
                                            </div>}
                                    </div>
                                </Grid.Column>)}
                            </Grid.Row>
                        </Grid>
                    </div>
                </div>


            </div>



        </>
    );
};

export default Rewards;
